import React from 'react';
import { useRecoilValue } from 'recoil';
import { blockMaxSubjects, blockRequestSubjects, blockSettings } from 'venn-state';
import { isPublicPrivateAssetGrowthBlock, plural, withSuspense } from 'venn-utils';
import { Warning } from 'venn-ui-kit';

/** Warning message about subjects being excluded from the selected block. */
export const ExcludedSubjectsMessage = withSuspense(null, ({ selectedBlockId }: { selectedBlockId: string }) => {
  const subjects = useRecoilValue(blockRequestSubjects(selectedBlockId));
  const blockType = useRecoilValue(blockSettings(selectedBlockId)).customBlockType;
  const maxSubjects = useRecoilValue(blockMaxSubjects(selectedBlockId));

  if (subjects.length <= maxSubjects) {
    return null;
  }

  const maxSubjectsMsg = isPublicPrivateAssetGrowthBlock(blockType)
    ? 'This block accommodates a maximum of 1 Returns-Based subject and 1 Private Asset subject'
    : `This block accommodates a max of ${maxSubjects} ${plural(maxSubjects, {
        1: 'subject',
        other: 'subjects',
      })}`;

  return (
    <Warning
      text={`${maxSubjectsMsg}. ${subjects.length - maxSubjects} 
        ${plural(subjects.length - maxSubjects, {
          1: ' applicable subject has',
          other: 'applicable subjects have',
        })} been excluded`}
    />
  );
});
